// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1rEZl","error":"Textarea_error__2ITSf","readonly":"Textarea_readonly__3WftX","disabled":"Textarea_disabled__2bZAM"};